<template>
    <div :class="mainClass">
        <aside class="right-panel">
            <div class="right-panel__content">
                <div class="right-panel__header">
                    <span>事件信息</span>
                </div>
                <div class="right-panel__content-body">
                    <YScroll style="height: 100%">
                        <el-form
                            ref="cForm"
                            :model="categoryFormData"
                            :rules="formRules"
                            :disabled="editStatus"
                        >
                            <el-form-item label="事件分类" prop="eventTypeId" class="form-item">
                                <el-cascader
                                    popper-class="popperCascader"
                                    v-model="categoryFormData.eventTypeId"
                                    :props="{ value: 'id', label: 'name', emitPath: false }"
                                    style="width: 100%"
                                    filterable
                                    clearable
                                    :options="eventTypeOptions"
                                    @change="onEventTypeChange"
                                ></el-cascader>
                            </el-form-item>
                            <el-form-item label="事件名称" prop="name" class="form-item">
                                <el-input
                                    v-model="categoryFormData.name"
                                    size="default"
                                    :maxlength="50"
                                    placeholder="请输入事件名称"
                                ></el-input>
                            </el-form-item>

                            <el-form-item label="经纬度" prop="longitude" class="form-item">
                                <LngLatInput
                                    :longitude="categoryFormData.longitude"
                                    :latitude="categoryFormData.latitude"
                                    size="default"
                                    @change="handleLngLatChange"
                                >
                                    <!-- <template #append>
                                    <el-button class="btn-pick-up" type="primary" @click="showAmapVisible()"
                                        >拾取</el-button
                                    >
                                </template> -->
                                </LngLatInput>
                            </el-form-item>
                            <el-form-item label="所属区域" prop="areaId" class="form-item">
                                <el-cascader
                                    popper-class="popperCascader"
                                    v-model="categoryFormData.areaId"
                                    style="width: 234px"
                                    placeholder="请选择所属区域"
                                    :props="{ value: 'id', label: 'label' }"
                                    :options="areaList"
                                    clearable
                                    filterable
                                    @change="changeArea"
                                ></el-cascader>
                            </el-form-item>
                            <el-form-item label="地址" class="form-item">
                                <el-input
                                    v-model="categoryFormData.location"
                                    size="default"
                                    :maxlength="50"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="发现人" prop="reportUser" class="form-item">
                                <el-input
                                    v-model="categoryFormData.reportUser"
                                    :disabled="true"
                                    size="default"
                                    :maxlength="20"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="事件描述" prop="content" class="form-item">
                                <el-input
                                    v-model="categoryFormData.content"
                                    size="default"
                                    type="textarea"
                                    :maxlength="500"
                                    resize="none"
                                    :autosize="{ minRows: 2, maxRows: 6 }"
                                    show-word-limit
                                ></el-input>
                            </el-form-item>

                            <el-form-item label="上报接收部门" class="form-item">
                                <select-tree
                                    :value="categoryFormData.deptId"
                                    :list="deptTree"
                                    :treeprops="unitprops"
                                    :placeholder="$t('taskPage.taskAdd.selectApplyDept')"
                                    :checkStrictly="true"
                                    @change="UnitChange"
                                ></select-tree>
                            </el-form-item>
                        </el-form>
                    </YScroll>
                    <div class="bottom-btn">
                        <el-button style="padding: 8px 16px" size="default" @click="resetFormData"
                            >重置</el-button
                        >
                        <el-button
                            style="padding: 8px 16px"
                            v-show="!categoryFormData.deptId"
                            size="default"
                            type="primary"
                            @click="save()"
                            >保存事件</el-button
                        >
                        <el-button
                            style="padding: 8px 16px"
                            v-show="categoryFormData.deptId"
                            size="default"
                            type="primary"
                            @click="save()"
                            >保存并上报事件</el-button
                        >
                    </div>
                </div>
            </div>
        </aside>

        <div class="annotator-wrap-middle">
            <header class="toolbar-wrap toolbar-wrap__horizontal">
                <div class="annotator-Tool">
                    <AnnotatorTool
                        :tool-activity="toolActivity"
                        :event-can-edit="eventCanEdit"
                        @tpChange="tpChange"
                        @setZoom="setImgZoom"
                    />
                </div>
            </header>
            <div class="annotator-middle-panel">
                <div
                    id="frame"
                    ref="annotatorFrame"
                    class="annotator-frame"
                    :style="{
                        cursor: cursor,
                        width: '50%',
                    }"
                >
                    <Annotation
                        v-if="annotatorShow"
                        id="myTagging"
                        ref="myTagging"
                        class="myTagging"
                        style="width: 98%"
                        :show-right="showRight"
                        :img-src="image.imageUrl"
                        :anno-list="annoList"
                        :tool-activity="toolActivity"
                        :img-zoom="imgZoom"
                        :event-can-edit="eventCanEdit"
                        @taggingChange="taggingChange"
                    />
                </div>
                <div class="annotator-map" style="width: '50%'">
                    <MapContainer
                        ref="map"
                        :showZoomTool="false"
                        :showBottom="false"
                        :center="positionVal"
                        :zoom="18"
                    >
                        <template slot="openlayer">
                            <LDrawPoint :mapObj="mapObj" @bindModify="bindLatlng" />
                            <!-- <LMarker :imgUrl="MarkerImg" :positionVal="positionVal" /> -->
                        </template>
                    </MapContainer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';

// eslint-disable-next-line import/no-unresolved
import { LMarker, LDrawPoint } from '@OpenLayersCommon';
// import 'swiper/swiper-bundle.css';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import LayerGroup from 'ol/layer/Group.js';
import ExifUtil from '@/page/Annotator/util/EXIFUtil.js';
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import {
    ImgUpload,
    getEventMark,
    updateEventMark,
    delMarkEvent,
    areaTree,
    getAddress,
    getEventTypeTree,
    deptTreeSelect,
    listMapconfig,
    getDefault,
} from '../api/annotator.js';
// import { getUserProfile } from '@/api/system/user';

import Annotation from './annotator/Annotation.vue';
import LngLatInput from './LngLatInput/LngLatInput.vue';
// import FormDetail from './components/annotator/FormDetail/FormDetail.vue';
// import './styles/tooltip.css';
import * as ValidatUtil from '@/page/Annotator/util/validator.js'; // './util/validator';

import { getNowTime } from '@/utils/common.js';
import AnnotatorTool from './tool/index.vue';
import TypeAmap from '@/page/Annotator/components/CAmap/TypeAmap.vue';

// import useUserStore from '@/store/modules/user';

export default {
    props: {
        imageObj: {
            type: Object,
            default: () => ({
                filePathUrl: require('./image/1.jpg'),
                imageUrl: require('./image/1.jpg'),
                filename: 'ceshi.jpg',
                filePath: require('./image/1.jpg'),
                url: require('./image/1.jpg'),
                raster: {
                    source: '',
                },
                dataId: 'dataId',
                id: 'id',
            }),
        },
    },
    components: {
        YScroll,
        Annotation,
        LngLatInput,
        // FormDetail,
        AnnotatorTool,
        MapContainer,
        LMarker,
        LDrawPoint,
    },

    data() {
        return {
            MarkerImg: require('./image/marker-pinlet.png'),
            positionVal: [113.121586, 23.021351],
            bottomToolConfig: {
                showFly: false,
            },
            route: {
                id: '',
            },
            eventMark: { code: '', name: '', dataType: 2, dataList: [], eventList: [] }, // 标注工单汇总字段

            disabled: true,
            annotatorShow: true,
            editStatus: false,
            imgZoom: {
                type: '',
                num: 0,
            },
            markId: null, // 标注任务Id
            areaList: [], // 所属区域列表
            location: null,
            toolActivity: {
                id: -1,
                name: '',
            },
            cursor: 'move',
            image: {
                raster: {},
                scale: 0,
                ratio: 0,
                data: null,
                url: '',
                filePathUrl: '',
                imageUrl: '',
                filename: 'ceshi.jpg',
                filePath: '',
                id: '',
                dataId: '',
                metadata: {
                    longitude: '',
                    latitude: '',
                },
            },
            areaId: '',
            current: {
                category: -1,
                annotation: -1,
                keypoint: -1,
            },
            eventTypeOptions: [], // 事件分类
            formRules: {
                name: [{ required: true, message: '名称不能为空!', trigger: 'blur' }],
                eventTypeId: [{ required: true, message: '事件分类不能为空!', trigger: 'change' }],
                longitude: [{ required: true, validator: this.lngLatValidator, trigger: 'blur' }],
                areaId: [{ required: true, message: '所属社区不能为空!', trigger: 'blur' }],
            },
            currentAnno: {
                data: {},
            },
            annoList: [],
            myTagging: null,
            imgBase64Blob: null,
            showRight: false,
            mapLayer: null,
            Maploading: false,
            baseParams: {
                baseUrl: '',
                params: {
                    LAYERS: '',
                    CQL_FILTER: '',
                    TILED: true,
                    projection: '',
                    authkey: 'guan',
                },
            },
            mapObj: {
                type: 'add',
                iconUrl: require('./image/marker-pinlet.png'), // markerPinlet,
                geometry: [113.121586, 23.021351],
            },

            categoryFormData: {},
            deptTree: [],
            Unitoptions: [],
            unitprops: {
                value: 'id',
                label: 'label',
                children: 'children',
                multiple: false,
                expandTrigger: 'hover',
            },
            markerList: [],
            useUserStore: this.$store.state.userInfo.userInfo.user, // 用户信息
        };
    },

    computed: {
        mainClass() {
            let cl = ['annotator-wrap '];
            if (this.isVideo) {
                cl.push('is-video');
            }
            return cl;
        },
        eventCanEdit() {
            let eventStatus = this.categoryFormData.status;
            return false; // eventStatus === 1 || eventStatus === '1' || !eventStatus;
        },
    },

    watch: {
        imageObj: {
            handler(newVal) {
                this.image = {
                    ...this.image,
                    ...newVal,
                };
                this.getImage(this.image);
            },
            immediate: true,
            deep: true,
        },
        categoryFormData: {
            handler(newVal) {
                // console.log('categoryFormData', newVal);
            },
            deep: true,
        },
    },

    methods: {
        getImage(imageObj) {
            // 解析图片元数据获取Gps信息
            ExifUtil.getGPS(imageObj.filePathUrl, async (gpsInfo) => {
                if (gpsInfo) {
                    let { longitude, latitude } = gpsInfo;

                    if (longitude && latitude) {
                        this.categoryFormData.longitude = longitude;
                        this.categoryFormData.latitude = latitude;
                        this.categoryFormData.taskId = imageObj.taskId;
                        this.image.metadata.longitude = longitude;
                        this.image.metadata.latitude = latitude;
                        this.mapObj.geometry = [longitude, latitude];
                        this.mapObj.type = 'edit';
                        this.bindLocation({ latitude, longitude });
                    } else {
                        this.mapObj.type = 'add';
                    }
                }
            });
        },
        UnitChange() {},
        async taggingChange(e, num) {
            // 假设 promise 是您已经有的 Promise 对象
            if (num == 0) {
                let base64Blob = this.base64ToBlob(e.img);
                let fileObj = new File([base64Blob], `annotation${Date.now()}.png`, {
                    type: base64Blob.type,
                }); // 将Blob对象转换为File对象
                let formData = new FormData();
                formData.append('file', fileObj);
                this.imgBase64Blob = formData;
                this.categoryFormData.markJsonPath = JSON.stringify(e.markJsonPath);
            } else {
                this.imgBase64Blob = null;
                this.categoryFormData.markJsonPath = null;
            }
        },

        // 验证经纬度
        lngLatValidator(rule, value, callback) {
            let lng = this.categoryFormData.longitude;
            let lat = this.categoryFormData.latitude;

            if (lng || lat) {
                if (ValidatUtil.checkLongitude(lng) && ValidatUtil.checkLatitude(lat)) {
                    callback();
                } else {
                    callback(new Error('请输入正确的经纬度坐标!'));
                }
            } else {
                callback(new Error('必填项不能为空!'));
            }
        },

        tpChange(e) {
            if (e.id === this.currentAnno.data.id) return;
            let obj = { id: e.id, name: e.name };
            this.currentAnno.data = obj;
            this.toolActivity = obj;
        },

        setImgZoom(e) {
            this.imgZoom = {
                num: e.num,
                type: e.type,
            };
        },

        base64ToBlob(base64) {
            let arr = base64.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bstr = window.atob(arr[1]);
            let n = bstr.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },

        changeArea(e) {
            this.categoryFormData.areaId = e ? e[e.length - 1] : '';
        },

        onEventTypeChange(id) {
            let eventType = this.findTreeNode(id, this.eventTypeOptions);
            if (!this.categoryFormData.id) {
                this.categoryFormData.name = `${eventType?.name || ''}-${getNowTime()}`;
            }
            this.categoryFormData.deptId = eventType && eventType.deptList?.length > 0 ? eventType.deptList[0].id : '';
        },

        // eslint-disable-next-line consistent-return
        findTreeNode(id, list) {
            for (let i = 0; i < list.length; i++) {
                if (list[i].id === id) {
                    return list[i];
                }
                if (list[i].children && list[i].children.length >= 1) {
                    let obj = this.findTreeNode(id, list[i].children);
                    if (obj != null) return obj;
                }
            }
        },

        // 修改事件地址
        bindLatlng(val) {
            let latlng = val;
            if (latlng.length > 0) {
                this.categoryFormData.longitude = latlng[0].toFixed(9);
                this.categoryFormData.latitude = latlng[1].toFixed(9);
                this.bindLocation(latlng);
            }
        },

        async bindLocation(lngLat) {
            const location = await getAddress({
                lng: lngLat[0],
                lat: lngLat[1],
            });
            if (location.code === 200) {
                this.categoryFormData.location = location.msg;
            }
        },

        CreateCategoryFormData() {
            let obj = {
                name: '',
                eventTypeId: '',
                location: '',
                source: 'M',
                eventTime: '',
                longitude: '113.121586',
                latitude: '23.021351',
                areaId: '',
                taskId: '',
                markId: this.markId || '',
                reportUser: this.useUserStore.userName,
                remark: '',
                dataId: this.image.dataId || '',
                jurisdictionId: '',
                jurisdictionName: '',
                categoryFormData: -1,
                markJson: '',
                filePath: '',
                markJsonPath: '',
            };

            if (this.image.metadata) {
                let { longitude, latitude } = this.image.metadata;
                obj.longitude = longitude || '';
                obj.latitude = latitude || '';
                obj.location = this.location;
            }
            return obj;
        },

        clearValidate() {
            if (this.cForm) {
                this.$nextTick(() => {
                    if (this.cForm) {
                        this.cForm.clearValidate();
                    }
                });
            }
        },

        createAnnotation() {
            let width = this.image.raster.width;
            let height = this.image.raster.height;
            return {
                id: this.image.id,
                area: 0,
                bbox: [0, 0, 0, 0],
                category_id: '',
                color: '#54CCFF01',
                creator: '',
                deleted: false,
                events: [],
                height,
                image_id: this.image.id,
                isbbox: false,
                iscrowd: false,
                keypoints: [],
                metadata: {},
                milliseconds: 0,
                paper_object: [],
                segmentation: [],
                width,
            };
        },

        async save() {
            let data = {};
            if (this.categoryFormData.markJsonPath && this.categoryFormData.markJsonPath.length > 10) {
                let imgData = await ImgUpload(this.imgBase64Blob);
                if (imgData) {
                    data = {
                        ...this.categoryFormData,
                        name: this.categoryFormData.name,
                        areaId: this.categoryFormData.areaId,
                        location: this.categoryFormData.location,
                        id: this.categoryFormData.id || null,
                        jurisdictionId: this.categoryFormData.jurisdictionId,
                        jurisdictionName: this.categoryFormData.jurisdictionName,
                        longitude: this.categoryFormData.longitude,
                        latitude: this.categoryFormData.latitude,
                        remark: this.categoryFormData.remark,
                        eventTypeId: this.categoryFormData.eventTypeId,
                        filePath: imgData.data.filename,
                        filePathUrl: imgData.data.url,
                        markJsonPath: this.categoryFormData.markJsonPath,
                        eventTime: this.getTime(),
                    };

                    if (this.categoryFormData.deptId) {
                        let dept = this.findTreeNode(this.categoryFormData.deptId, this.deptTree);
                        data.deptList = dept ? [{ id: dept.id, name: dept.name }] : [];
                    }

                    if (this.cForm) {
                        this.cForm.validate(async (valid) => {
                            this.disabled = true;
                            let list = [];
                            if (valid) {
                                if (this.eventMark.eventList.length > 0) {
                                    let eventObj = this.eventMark.eventList.find(
                                        (cell) => cell.id === data.id,
                                    );
                                    if (eventObj) {
                                        this.eventMark.eventList.forEach((item) => {
                                            if (item.id === data.id) {
                                                list.push({ ...item, ...data });
                                            } else {
                                                list.push(item);
                                            }
                                        });
                                        this.eventMark.eventList = list;
                                    } else {
                                        this.eventMark.eventList.push(data);
                                    }
                                } else {
                                    this.eventMark.eventList = [data];
                                }
                                await this.bindUpdateEventMark(this.eventMark);
                            }
                        });
                    }
                }
            } else {
                this.$message({
                    type: 'error',
                    message: '请在图中标注事件源！',
                });
            }
        },

        async bindUpdateEventMark(obj) {
            try {
                const res = await updateEventMark(obj);
                if (res && res.code === 200) {
                    this.$message({ type: 'success', message: '保存成功！' });
                    this.disabled = true;
                    this.annoList = [];
                    this.resetFormData();
                }
            } catch (err) {
                this.disabled = false;
            }
        },

        getTime() {
            let now = new Date();
            let nowDay = now.getDate();
            let nowMonth = now.getMonth() + 1;
            let nowYear = now.getFullYear();
            let nowHours = now.getHours();
            let nowMinutes = now.getMinutes();
            let nowSeconds = now.getSeconds();

            let Month = nowMonth < 10 ? `0${nowMonth}` : nowMonth;
            let Day = nowDay < 10 ? `0${nowDay}` : nowDay;
            let Hours = nowHours < 10 ? `0${nowHours}` : nowHours;
            let Minutes = nowMinutes < 10 ? `0${nowMinutes}` : nowMinutes;
            let Seconds = nowSeconds < 10 ? `0${nowSeconds}` : nowSeconds;

            return `${nowYear}-${Month}-${Day} ${Hours}:${Minutes}:${Seconds}`;
        },

        resetFormData() {
            this.disabled = false;
            this.categoryFormData = this.CreateCategoryFormData();
            this.$nextTick(() => {
                this.clearValidate();
            });
        },

        handleLngLatChange(e) {
            this.setArea();
        },

        setArea() {
            const { longitude, latitude, address } = this.categoryFormData;
            if (longitude && latitude) {
                let area = [
                    {
                        type: 'circle',
                        radius: 0,
                        area: 0,
                        longitude,
                        latitude,
                        name: address,
                    },
                ];
                this.categoryFormData.location = area;
            }
        },

        async getEventType() {
            const res = await getEventTypeTree();
            this.eventTypeOptions = res.data;
        },

        async getDeptTree() {
            const res = await deptTreeSelect();
            this.deptTree = res.data;
        },

        async getAreaFindList() {
            const res = await areaTree();
            this.areaList = this.treeToList(res.data, []);
        },

        treeToList(tree, list) {
            tree.forEach((item) => {
                if (item.children) {
                    this.treeToList(item.children, list);
                } else {
                    list.push(item);
                }
            });
            return list;
        },

        onWindowResize() {},
    },

    mounted() {
        this.$nextTick(() => {
            this.categoryFormData = this.CreateCategoryFormData();
            this.getAreaFindList();
            this.getEventType();
            this.getDeptTree();

            // 保留原始注释
            // mousewheelevt = /Firefox/i.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel';
        });
        window.addEventListener('resize', this.onWindowResize);
        // console.log('this.$store.state.userInfo.userInfo', this.$store.state.userInfo.userInfo);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
    },
};
</script>

<style lang="scss" scoped>
.annotator-wrap {
    margin-top: 10px;
    height: 660px;
    background-color: #071150;
    overflow: hidden;
}
.toolbar-wrap {
    background-color: #071150;
    border-bottom: 1px solid #e7e7e7;
}
.toolbar-wrap__horizontal {
    display: flex;
    box-sizing: border-box;
    height: 35px;
    line-height: 0;
    align-items: center;
    justify-content: space-between;
    .annotator-Tool {
        display: flex;
        flex: 1;
    }
    .annotator-model {
        display: flex;
        color: white;
        font-size: 14px;
        margin-right: 15px;
        .model-1 {
            cursor: pointer;
            height: 26px;
            line-height: 22px;
            background: rgba(29, 33, 45, 0.6);
            border-radius: 2px 2px 2px 2px;
            padding: 2px 5px;
            margin: 0 5px;
        }
        .model-activity {
            background: #2e7df8;
        }
    }
}
.toolbar-wrap__horizontal .annotator-tool-item {
    margin-left: 16px;
}
.toolbar-wrap__horizontal .annotator-tool-item .toolbar-icon {
    display: inline-block;
    height: 24px;
    width: auto;
}
.annotator-wrap-middle {
    display: block;
    height: 100%;
    /* position: relative; */
}
.annotator-middle-panel {
    width: inherit;
    height: 650px; //calc(100% - 54px);
    background-color: #071150;
    overflow: hidden;
    position: relative;
    display: flex;
    padding: 16px 16px 0 0;
    .annotator-frame {
        flex: 1;
        margin: 0;
        height: 100%;
        position: relative;
    }
    .annotator-map {
        flex: 1;
    }
}

.right-panel {
    float: right;
    height: inherit;
    background: #071150;
    border-left: 1px solid #e7e7e7;
    .form-mask {
        position: absolute;
        top: 0px;
        right: 0px;
        left: 0px;
        bottom: 0px;
        cursor: not-allowed;
        z-index: 1000;
    }
    .form-item {
        .btn {
            padding: 5px;
        }
        ::v-deep .el-input-group__append {
            border: 0;
            vertical-align: baseline;
        }

        .btn-pick-up {
            height: 33px;
            background-color: #409eff;
            color: #ffffff;
            border-color: #409eff;
            border: 0;
            border-radius: 0 4px 4px 0;
        }
    }
}

.right-panel .right-panel__content .right-panel__content-body {
    position: relative;
    padding: 16px 0 0 16px;
    overflow: hidden;
    height: 630px;
    width: 260px;
    padding-bottom: 60px;
    .bottom-btn {

        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        background: #040a3580;
        // border: 1px red solid;
        padding: 20px 0;
        display: flex;
        justify-content:space-around;
    }

    ::v-deep .el-input__count {
        background: none;
    }
}
::v-deep .right-panel .right-panel__content .el-form-item__label {
    line-height: 1.5;
    margin-bottom: 8px;
    display: block;
    color: #ffffff;
}
::v-deep .right-panel .right-panel__content .el-form-item {
    margin-bottom: 16px;
    display: block;
    color: #ffffff;
}

.right-panel .right-panel__content .right-panel__header {
    font-weight: bold;
    padding: 0 16px;
    height: 35px;
    display: flex;
    align-items: center;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #e7e7e7;
    box-sizing: border-box;
    color: #ffffff;
}

::v-deep.form-item .el-input__inner,
::v-deep.form-item .el-textarea__inner {
    // width: 288px;
    background: #071150;
    border: 1px #1a47a4 solid;
    color: white;
    height: 33px;
    // min-width: 223px;
}
::v-deep.form-item .el-input__count {
    color: white;
}

::v-deep.form-item .el-input__suffix {
    right: 1px;
    font-size: 18px;
    line-height: 25px;
}

::v-deep.form-item .el-icon-search {
    color: white;
    border-radius: 0 4px 4px 0;
    width: 32px;
    height: 32px;
    // margin-top: 1px;
    font-size: 18px;
    line-height: 32px;
    background: #154fdb;
}
::v-deep .form-item {
    ::v-deep .el-cascader:not(.is-disabled):hover .el-input__inner {
        border-color: #112d7b;
    }
    ::v-deep .el-cascader .el-input .el-input__inner:focus,
    .el-cascader .el-input.is-focus .el-input__inner {
        border-color: #112d7b;
    }
    ::v-deep .el-cascader .el-input .el-input__inner {
        color: #fff;
    }
}
</style>
